module.exports = __webpack_public_path__ + "static/media/S1_00010.7dc7ed2e.jpg";